import { animate, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { select, Store } from '@ngrx/store';

import { DateTime } from 'luxon';
import { BehaviorSubject, combineLatest } from 'rxjs';

import * as fromWalkingFarmSelectors from '../../../store/selectors/walking-farm.selectors';

@Component({
  animations: [
    trigger('expandCollapse', [
      state('true', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
      state('false', style({ height: '64px', visibility: 'hidden' })),
      transition('false => true', animate(320 + 'ms ease-in')),
      transition('true => false', animate(320 + 'ms ease-out'))
    ]),
    trigger('showInOutAnimation', [
      transition(':enter', [style({ height: 0 }), animate('160ms ease-out', style({ height: 64 }))]),
      transition(':leave', [style({ height: 64 }), animate('160ms ease-in', style({ height: 0 }))])
    ])
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-contact-card',
  standalone: false,
  styleUrls: ['./contact-card.component.scss'],
  templateUrl: './contact-card.component.html'
})
export class ContactCardComponent {
  private changeDetectorRef = inject(ChangeDetectorRef);
  private router = inject(Router);
  private store = inject(Store);

  showCard = false;

  showFullCard = false;

  showFullCardTapDate: DateTime | null = null;

  currentPageBaseUrl: BehaviorSubject<string> = new BehaviorSubject('/');

  constructor() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentPageBaseUrl.next(event.url);
        this.changeDetectorRef.detectChanges();
      }
    });

    combineLatest([
      this.currentPageBaseUrl,
      this.store.pipe(select(fromWalkingFarmSelectors.selectDrawMode))
    ]).subscribe(([pageUrl, drawMode]) => {
      this.showCard = ['/', '/property-search', '/calculators', '/walking-farm'].includes(pageUrl);
      if (pageUrl === '/walking-farm' && drawMode) {
        this.showCard = false;
      }
      this.showFullCard = false;
      this.changeDetectorRef.detectChanges();
    });
  }

  toggleCardSize() {
    if (this.showFullCardTapDate) {
      if (DateTime.now().diff(this.showFullCardTapDate, 'milliseconds').milliseconds < 500) {
        this.showFullCard = !this.showFullCard;
      } else {
        this.showFullCardTapDate = DateTime.now();
      }
    } else {
      this.showFullCardTapDate = DateTime.now();
    }
  }
}
